import type { Unit } from '@dynatrace-sdk/units';

import { clusterizeNodes } from './clusterize-nodes.js';
import { getFilteredTree } from './get-filtered-tree.js';
import { getMappedTree } from './get-mapped-tree.js';
import type { TreeMapFormatter } from '../types/internal.js';
import type { TreeMapRootNode } from '../types/treemap.js';

export function mapToInternalTree(
  tree: TreeMapRootNode,
  formatter: TreeMapFormatter,
  unit?: string | Unit,
) {
  const clusterizedTree = clusterizeNodes(tree);
  const mappedTree = getMappedTree(clusterizedTree, formatter, unit);
  const filteredTree = getFilteredTree(mappedTree);

  return filteredTree;
}
